<template>
  <footer>
    <div v-for="partner in partners" class="footer-sponsor">
      <div class="footer-sponsor__column">
        <div class="footer-sponsor__label">{{ partner.title }}</div>
        <div class="footer-sponsor__sponsor-logo">
          <img class="footer-sponsor__image" :src="'/images/partners/' + partner.id + '/' + partner.logo">
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer__about">
        Образовательные программы и курсы повышения квалификации для медицинских работников
      </div>
      <router-link :to="{ name: 'agreement' }" class="footer__agreement">
        Пользовательское соглашение
      </router-link>
      <router-link :to="{ name: 'faq' }" class="footer__agreement">
        Часто задаваемые вопросы
      </router-link>
      <router-link :to="{ name: 'cookies' }" class="footer__agreement">
        Cookie файлы
      </router-link>
      <router-link :to="{ name: 'support' }" class="footer__agreement">
        Обратиться в техподдержку
      </router-link>
      <div class="footer__copyright">
        © Санкт-Петербург 2021
      </div>
    </div>
    <cookies-alert></cookies-alert>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import PagesService from '~/services/pages'
import CookiesAlert from "./CookiesAlert";

export default {
  components: {
    CookiesAlert
  },
  data: () => ({
    partners: [],
  }),
  computed: {
    ...mapGetters({
       user: 'auth/user',
     }),
  },
  watch:{
    $route (to, from){
      const pageInfo = PagesService.getPageInfo(this.$router);
      console.log(pageInfo);

      if (pageInfo) {
        this.partners = pageInfo.partners;
      }
    }
  },
  methods: {

  },
  beforeMount () {
    const pageInfo = PagesService.getPageInfo(this.$router);
    if (pageInfo) {
      this.partners = pageInfo.partners;
    }
  },
}
</script>
